
export default {
  name: 'LoginLayout',
}
